import { AxiosError } from 'axios';

import { call, put, select, takeLeading } from 'redux-saga/effects';

import apiOffers from 'api/offers';

import { finishLoading, startLoading } from '../loading/actions';

import { FETCH_OFFER_TYPES, FETCH_STATUS_TYPES } from './types';

/**
 * The fixed lists of the offers are read once: a page asking for them again uses the list
 * already read. The loading spinner is cleared also when reading fails.
 */
function* fetchTypes(
  type: { PENDING: string; SUCCESS: string; FAILURE: string },
  variableName: string,
  apiEndpoint: () => Promise<unknown>
) {
  const currentValue: unknown[] = yield select(
    (state) => state.offers[variableName]
  );
  if (Array.isArray(currentValue) && currentValue.length > 0) {
    return;
  }

  try {
    yield put(startLoading(type.PENDING));
    const types = yield call(apiEndpoint);
    yield put({ type: type.SUCCESS, [variableName]: types });
  } catch (error) {
    const axiosError = error as AxiosError;
    yield put({ type: type.FAILURE, message: axiosError.message });
  } finally {
    yield put(finishLoading(type.PENDING));
  }
}

function* fetchOfferTypes() {
  yield fetchTypes(FETCH_OFFER_TYPES, 'offerTypes', apiOffers.offerTypes.get);
}

function* fetchStatusTypes() {
  yield fetchTypes(FETCH_STATUS_TYPES, 'statusTypes', apiOffers.status.get);
}

function* saga(): Generator {
  yield takeLeading(FETCH_OFFER_TYPES.PENDING, fetchOfferTypes);
  yield takeLeading(FETCH_STATUS_TYPES.PENDING, fetchStatusTypes);
}

export default saga;
